import { ArrowUpRight } from 'lucide-react';
import { BOOKING_URL } from '../constants';
import { gsap, ScrollTrigger, revealMedia, useMotion } from '../lib/motion';

// Preços, durações e fotos da agenda online (todetranca.app.br/nyjuliabraids)
const services = [
  { name: "Knotless Braids", price: "a partir de R$ 340", duration: "4h30+", image: "/estilos/knotless-braids.jpg", featured: true },
  { name: "Box Braids", price: "a partir de R$ 340", duration: "4h30+", image: "/estilos/box-braids.jpg" },
  { name: "Trança Nagô", price: "a partir de R$ 220", duration: "4h+", image: "/estilos/trancas-nago.jpg" },
  { name: "Twists", price: "a partir de R$ 160", duration: "2h+", image: "/estilos/twists.jpg" },
  { name: "Fulani Braids", price: "a partir de R$ 360", duration: "5h+", image: "/estilos/fulani-braids.jpg" },
  { name: "French Curl", price: "a partir de R$ 390", duration: "4h+", image: "/estilos/french-curl.jpg" },
];

export default function Services() {
  const scope = useMotion((root) => {
    const tiles = root.querySelectorAll('[data-tile]');
    tiles.forEach((tile) => delete tile.dataset.shown);
    gsap.set(root.querySelectorAll('[data-tile-caption]'), { autoAlpha: 0, y: 12 });
    gsap.set(root.querySelectorAll('[data-tile-media]'), { clipPath: 'inset(100% 0% 0% 0% round 16px)' });

    // Fotos da mesma fileira entram em cascata.
    ScrollTrigger.batch(tiles, {
      start: 'clamp(top 88%)',
      onEnter: (batch) => {
        batch.filter((tile) => !tile.dataset.shown).forEach((tile, i) => {
          tile.dataset.shown = 'true';
          const delay = i * 0.12;
          revealMedia(tile.querySelector('[data-tile-media]'), undefined, delay);
          const caption = tile.querySelector('[data-tile-caption]');
          if (caption) gsap.to(caption, { autoAlpha: 1, y: 0, duration: 0.8, delay: delay + 0.45 });
        });
      },
    });
  });

  return (
    <section ref={scope} id="servicos" data-testid="services-section" className="max-w-7xl mx-auto px-4 md:px-8 py-20 md:py-28">
      <div className="max-w-[60ch] mb-10 md:mb-14">
        <h2 data-lines className="text-4xl md:text-5xl font-extrabold tracking-tight leading-none text-ink mb-4">
          Escolha seu estilo
        </h2>
        <p data-rise="0.2" className="text-soft leading-relaxed">
          Valores iniciais. O preço final depende do tamanho e do comprimento, e aparece na agenda antes de confirmar.
        </p>
      </div>

      <div className="grid grid-cols-2 lg:grid-cols-4 gap-x-3 gap-y-8 md:gap-x-5" data-testid="services-grid">
        {services.map((service) => (
          <a
            key={service.name}
            href={BOOKING_URL}
            target="_blank"
            rel="noopener noreferrer"
            data-tile
            className={`group flex flex-col ${service.featured ? 'col-span-2 lg:row-span-2' : ''}`}
            data-testid={`service-card-${service.name.toLowerCase().replace(/\s+/g, '-')}`}
          >
            <div
              data-tile-media
              className={`overflow-hidden rounded-2xl bg-raised ${
                service.featured ? 'aspect-[4/5] lg:aspect-auto lg:flex-1' : 'aspect-[4/5]'
              }`}
            >
              <img
                src={service.image}
                alt={`${service.name} feitas no salão`}
                loading="lazy"
                className="w-full h-full object-cover motion-safe:transition-transform motion-safe:duration-700 group-hover:scale-[1.04]"
              />
            </div>
            <div data-tile-caption className="pt-3 flex items-start justify-between gap-3">
              <div>
                <h3 className={`font-bold text-ink ${service.featured ? 'text-2xl' : 'text-lg'}`}>
                  {service.name}
                </h3>
                <p className="text-sm text-soft">
                  {service.price} · {service.duration}
                </p>
              </div>
              <ArrowUpRight
                size={20}
                strokeWidth={1.75}
                aria-hidden="true"
                className="text-soft mt-1 shrink-0 group-hover:text-tan group-hover:-translate-y-0.5 group-hover:translate-x-0.5 transition"
              />
            </div>
          </a>
        ))}

        <a
          href={BOOKING_URL}
          target="_blank"
          rel="noopener noreferrer"
          data-tile
          className="group col-span-1 lg:col-span-3 flex"
          data-testid="services-cta-btn"
        >
          <span
            data-tile-media
            className="w-full rounded-2xl bg-tan text-paper p-5 md:p-8 flex flex-col lg:flex-row lg:items-end justify-between gap-4 group-hover:bg-ink transition-colors"
          >
            <span className="text-xl md:text-3xl font-extrabold tracking-tight leading-tight max-w-[22ch]">
              Mais 25 estilos, de gipsy braids a passion locs
            </span>
            <span className="inline-flex items-center gap-1 font-semibold lg:whitespace-nowrap">
              Ver todos na agenda
              <ArrowUpRight size={20} strokeWidth={1.75} aria-hidden="true" className="group-hover:-translate-y-0.5 group-hover:translate-x-0.5 transition" />
            </span>
          </span>
        </a>
      </div>
    </section>
  );
}
